import React from "react";
import { Grid } from "@mui/material";
import MainTitle from "../../muiHome/mainTitle";
import FacultyCard from "../../muiCommonComponent/facultyCards";

const FacultyList=()=>{
    const facultyList=[
        {img:'/assets/img/SSH/kuldeep.png',
        name:'Dr. Kuldeep Tanwar',
        position:'Dean School of SSH',
        email:'kuldeep.tanwar@mvn.edu.in', 
        gs: "https://scholar.google.com/citations?view_op=new_articles&amp;hl=en&amp;imq=Kuldeep+Tanwar#",
        linkedin: "https://www.linkedin.com/in/kuldeep-tanwar-",
        orcid: "https://orcid.org/0000-0002-0381-6043",
        rg: "https://www.researchgate.net/profile/Kuldeep-Tanwar-2",
        website: "#",
        aoi: "Operations Research",
        education: "Ph.D. (Mathematics)",
        re: "7",
        te: "15",
        iece: "N/A",
        articles:
          "<li>i. Tanwar K., Chauhan S. K. (2020), “Time-Cost Solution Pairs in Multi-Index Bulk Transportation Problem”. Communications in Computer and Information Science, Vol. 1230.</li><li> ii. Singh, S., Chauhan, S. K. and Kuldeep. (2018), “A Bi-Criteria Multi-Index Bulk Transportation Problem”. Annals of Pure and Applied Mathematics, Vol. 24.</li><li> iii. Tanwar, K. and Chauhan, S. K. (2021), “A Simple Algorithm for Fuzzy Time Minimizing Bulk Transportation Problem”. IEEE Transactions on Reliability, Infocom Technologies and Optimization.</li>",
        books:
          "N/A",
        chapters:
          "N/A",
        patents:
          "N/A",
        membership:
          "N/A",
        aa1: "N/A",
        aa2: "",
        aa3: "",
        aa4: "",
        aa5: "",
        aa6: "",},


        {img:'/assets/img/SSH/madhu.png',name:'Dr. Madhu',position:'Assistant Professor',email:'madhubala.ash@mvn.edu.in', gs: "https://scholar.google.com/citations?view_op=list_works&hl=en&user=7zZ8QN0AAAAJ",
        linkedin: "http://www.linkedin.com/in/madhu-tanwar-4a3370274",
        orcid: "#",
        rg: "https://www.researchgate.net/profile/Madhu-Bala-25",
        website: "#",
        aoi: "English Literature & Communication Skills",
        education: "Pursuing Ph.D. (English Literature)",
        re: "3.5",
        te: "6.4",
        iece: "N/A",
        articles:
          "<li>Dr. MadhuBala. Elements of English Language and Literature. Deccan International Academic Publishers. April 2025. DOI  10.5281/zendo.15259207.ISBN: 978-93-49092-41-9.E-ISBN:978-93-49092-11-2</li>",
        books:
          "1",
        chapters:
          "<li>1</li>",
        patents:
          "N/A",
        membership:
          "N/A",
        aa1: "Best Paper presentation Award",
        aa2: "Editor of SPL Journal",
        aa3: "Chairperson of Cultural Committee",
        aa4: "Chairperson of Alumni Committee",
        aa5: "Member of Women Cell",
        aa6: "Member of Dress Code Committee, Member of Canteen Committee",},


        {img:'/assets/img/SSH/geeta.png',name:'Dr. Geeta Sharma',position:'Assistant Professor',email:'geetasharma.ash@mvn.edu.in', gs: "https://scholar.google.com/citations?view_op=list_works&hl=en&user=7BGB8DYAAAAJ",
        linkedin: "http://www.linkedin.com/in/geeta-sharma-35b218304",
        orcid: "#",
        rg: "https://www.researchgate.net/profile/Geeta-Sharma-47",
        website: "#",
        aoi: "Sociology & Political Science",
        education: "Pursuing Ph.D. (Sociology)",
        re: "3.5",
        te: "5",
        iece: "N/A",
        articles:
          "<li>Geeta Sharma (2023) “Male Domestic Violence in Indian Scenario” in conference proceedings of DAVIM Faridabad. P 190-198</li><li>Geeta Sharma, B.P. Sing Thanua (2023) “Indigenous Tribes of Rajasthan: Reverse Migration- Impact on Their Lives During Covid-19” IJCRT Journal</li><li>Geeta Sharma, B.P. Sing Thanua, Poornima Jain (2024) “Impact of Covid 19 on forcefully displaced and migrant laborers of Faridabad: A study based on secondary sources” K.R Cama Oriental Institute Journal</li><li>Educational Impacts of the COVID-19 Pandemic: Challenges, Implication and Strategies for Resilience (In Progress)</li>",
        books:
          "N/A",
        chapters:
          "<li>Geeta Sharma, B.P. Sing Thanua, Poornima Jain (2023) “Suicide in India- scenario, causes and prevention” p 383-396 ISBN: 9789390253838</li><li>Geeta Sharma (2024) “Third Gender: Their History and Constitutional rights in India” ISBN-13 978-8196896287</li><li>NEP Implementation and Challenges (in progress)</li><li>Effect of Indian knowledge system on health and medicine during covid-19 A comparative analysis (in progress)</li>",
        patents:
          "N/A",
        membership:
          "N/A",
        aa1: "NET qualified in Political Science and Sociology",
        aa2: "Written mains of UPPSC seven times and appeared in interview four times, also written mains of RPSC and appeared in interview two times",
        aa3: "",
        aa4: "",
        aa5: "",
        aa6: "",},

        {img:'/assets/img/SSH/rahul_dagar.jpg ',
          name:'Dr. Rahul Dagar',
          position:'Assistant Professor',
          email:'rahul.dagar@mvn.edu.in',
          gs: "https://scholar.google.com/citations?user=GEs8WYEAAAAJ&hl=en",
          linkedin: "https://www.linkedin.com/feed/",
          orcid: "https://orcid.org/0009-0000-7737-5327",
          rg: "https://www.researchgate.net/profile/Rahul-Dagar",
          website: "#",
          aoi: "Condensed Matter Physics",
          education: "Ph.D.",
          re: "9",
          te: "2.5",
          iece: "N/A",
          articles:
            "15",
          books:
            "N/A",
          chapters:
            "4",
          patents:
            "N/A",
          membership:
            "N/A",
          aa1: "Best Poster presentation Award, Fellowship for Training Young Scientist Award, CSIR- UGC NET Qualified AIR-16, JEST Qualified AIR-98, and GATE Qualified.",
          aa2: "",
          aa3: "",
          aa4: "",
          aa5: "",
          aa6: "",},
        

        {img:'/assets/img/SSH/Lakshay_Singla.jpg ',
          name:'Mr. Lakshay Singla',
          position:'Lecturer',
          email:'Lakshay.singla@mvn.edu.in',
          gs: "NA",
          linkedin: "https://www.linkedin.com/in/lakshay-singla-3141361a3?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
          orcid: "NA",
          rg: "NA",
          website: "#",
          aoi: "Political Science",
          education: "MA political Sc.",
          re: "NA",
          te: "NA",
          iece: "2",
          articles:
            "N/A",
          books:
            "N/A",
          chapters:
            "N/A",
          patents:
            "N/A",
          membership:
            "N/A",
          aa1: "NET Qualified",
          aa2: "",
          aa3: "",
          aa4: "",
          aa5: "",
          aa6: "",},


          {img:'/assets/img/SSH/sagar.png',
          name:'Mr. Sagar Tanwar	',
          position:'Assistant Professor',
          email:'Sagar.ash@mvn.edu.in',
          gs: "NA",
          linkedin: "NA",
          orcid: "NA",
          rg: "NA",
          website: "#",
          aoi: "",
          education: "B.Sc. , M.Sc. Mathematics",
          re: "NA",
          te: "3",
          iece: "NA",
          articles:
            "N/A",
          books:
            "N/A",
          chapters:
            "N/A",
          patents:
            "N/A",
          membership:
            "N/A",
          aa1: "Qualified Htet",
          aa2: "",
          aa3: "",
          aa4: "",
          aa5: "",
          aa6: "",},


          {img:'/assets/img/SSH/Sakshi_Rawat.jpg ',
          name:'Ms. Sakshi Rawat',
          position:'Assistant Professor',
          email:'sakshi.rawat@mvn.edu.in',
          gs: "NA",
          linkedin: "https://www.linkedin.com/in/sakshi-rawat-986360366?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
          orcid: "NA",
          rg: "NA",
          website: "#",
          aoi: "Mathematics ",
          education: "B.Sc. , M.Sc. Mathematics",
          re: "NA",
          te: "1.5",
          iece: "6 Months",
          articles:
            "N/A",
          books:
            "N/A",
          chapters:
            "N/A",
          patents:
            "N/A",
          membership:
            "N/A",
          aa1: "Cultural Coordinator, School of Sciences & Humanities (SoSH),MVN University",
          aa2: "Member, Editorial Board Committee, MVN University",
          aa3: "Member, Website Updating Committee, MVN University",
          aa4: "President, Ramanujan – The Mathematical Society, J.C. Bose UST(2023–24)",
          aa5: "Joint Secretary, Vasundhara – The Eco Club, J.C. Bose UST(2023-24)",
          aa6: "NSS Coordinator, J.C Bose UST(2023-24)",},


           {img:'/assets/img/SSH/srishti_Aggarwal.jpg',
          name:'Ms. Srishti Aggarwal',
          position:'Assistant Professor',
          email:'srishti.aggarwal@mvn.edu.in',
          gs: "NA",
          linkedin: "NA",
          orcid: "NA",
          rg: "NA",
          website: "#",
          aoi: "English Literature",
          education: "B.A. Eng(H), MA English, UGC NET",
          re: "NA",
          te: "1.2 Years",
          iece: "N/A",
          articles:
            "N/A",
          books:
            "N/A",
          chapters:
            "N/A",
          patents:
            "N/A",
          membership:
            "N/A",
          aa1: "Procured 4th Rank in MDU merit list ",
          aa2: "Rohtak. (MA English,1st semester)",
          aa3: " 6th Rank in MDU merit list",
          aa4: "Rohtak. (MA English, 2nd semester)",
          aa5: "12th Rank in MDU merit list",
          aa6: "Rohtak. (MA English, 3rd Semester) and Overall Rank 9th in MDU merit list, Rohtak.",
          aa7: "Achieved Best Student of the Year Award, for excellence in Academics and Extra Curricular Activities, Worked as a Student Editor of college magazine 'Wageeshwari'",
          aa8: "Appointed as a President of English Literary Society",
          aa9: "Attained 1st position in the English Olympiad", 
          aa10: "Secured 2nd Position in State level Essay Writing Competition",
          aa11: "2nd Position in G20 University Connect Essay Writing Competition",
          aa12: "2nd Position in State Level Online Essay Writing Competition",
          aa13: "Achieved 1st Position in National Level Online Poetical Recitation Competition",
          aa14: "Awarded with Editor's Choice Award in International Creative Writing Olympiad",
          aa15: "Awarded a cash prize by the Ministry of Women and Child Development",
          aa16: "Government of India, on being one of the top 20 winners of the “The Spirit of Patriotism” Poetry Competition. Qualified UGC NET in English. Qualified CTET Paper II exam.",},

          
           {img:'/assets/img/SSH/vinika.jpg',
          name:'Ms. Vinika	',
          position:'Lecturer',
          email:'vinika.jakhar@mvn.edu.in',
          gs: "NA",
          linkedin: "NA",
          orcid: "NA",
          rg: "NA",
          website: "#",
          aoi: "Mathematics ",
          education: "B.Sc. , M.Sc. Mathematics ",
          re: "NA",
          te: "2",
          iece: "NA",
          articles:
            "N/A",
          books:
            "N/A",
          chapters:
            "N/A",
          patents:
            "N/A",
          membership:
            "N/A",
          aa1: " ",
          aa2: "",
          aa3: "",
          aa4: "",
          aa5: "",
          aa6: "",},


 
          
        
        
    ]
return(
    <Grid container spacing={2} sx={{margin:'10px 0px'}}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
            <MainTitle title='School of Science and Humanities'/>
        </Grid>
        {facultyList?.map((fac)=>(
        <Grid item xs={12} sm={12} md={4} lg={4}>
            <FacultyCard faculty={fac} />
        </Grid>
        ))}
    </Grid>
)
}
export default FacultyList;